import client from './client';
import type { ApiResponse, UserResponse, UpdateUserRequest, CreateUserRequest, BatchCreateUserRequest, BatchCreateUserResponse, UserNodeInfo } from './types';

export async function getUsers(): Promise<ApiResponse<UserResponse[]>> {
  return client.get('/users');
}

export async function getUser(id: string): Promise<ApiResponse<UserResponse>> {
  return client.get(`/users/${id}`);
}

export async function createUser(data: CreateUserRequest): Promise<ApiResponse<UserResponse>> {
  return client.post('/users', data);
}

export async function updateUser(id: string, data: UpdateUserRequest): Promise<ApiResponse<UserResponse>> {
  return client.put(`/users/${id}`, data);
}

export async function batchCreateUsers(data: BatchCreateUserRequest): Promise<ApiResponse<BatchCreateUserResponse>> {
  return client.post('/users/batch', data);
}

export async function getUserNodes(userId: string): Promise<ApiResponse<UserNodeInfo[]>> {
  return client.get(`/users/${userId}/nodes`);
}

export async function addUserNode(userId: string, nodeId: string): Promise<ApiResponse<Record<string, unknown>>> {
  return client.post(`/users/${userId}/nodes`, { nodeId });
}

export async function removeUserNode(userId: string, nodeId: string): Promise<ApiResponse<null>> {
  return client.delete(`/users/${userId}/nodes/${nodeId}`);
}
